import { Controller } from "@hotwired/stimulus"

// The sign-in pages' code email (sign_ins/_mail): the email as it's typed. On the code page, Send a new code counts
// down the half minute until another can go, and a button pressed says so and can't be pressed twice.
export default class extends Controller {
  static targets = ["email", "tagEmail", "again"]

  connect() {
    if (this.hasAgainTarget) this.countDown(Number(this.againTarget.dataset.wait) || 0)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  countDown(left) {
    const button = this.againTarget
    const words = button.textContent
    const tick = () => {
      if (left <= 0) {
        clearInterval(this.timer)
        button.disabled = false
        button.textContent = words
        return
      }
      button.disabled = true
      button.textContent = `Send a new code in ${left}s`
      left -= 1
    }
    tick()
    this.timer = setInterval(tick, 1000)
  }

  busy(event) {
    const button = event.target.querySelector("button[type=submit]")
    if (!button) return
    if (button.getAttribute("aria-disabled") === "true") return event.preventDefault()
    // Disabled only after the form has gone, so the browser still sends it.
    button.setAttribute("aria-disabled", "true")
    if (button.dataset.busy) button.textContent = button.dataset.busy
  }

  mirror() {
    const v = this.emailTarget.value.trim()
    this.tagEmailTarget.textContent = v || "you@example.com"
  }

  // Return sends the form itself: some browser extensions (password managers) catch the key in a sign-in field, and
  // then nothing happens. A word still being put together by a keyboard for another script isn't sent yet.
  send(event) {
    if (event.isComposing || event.keyCode === 229) return
    event.preventDefault()
    event.target.form?.requestSubmit()
  }

  // Keeps the code box to digits, so a pasted "123 456" or "Code: 123456" still works.
  digits(event) {
    const el = event.target
    const d = el.value.replace(/\D/g, "").slice(0, 6)
    if (d !== el.value) el.value = d
  }
}
